import React from "react";
import { Sparkles } from "lucide-react";
import { TYPE_LABELS } from "../../lib/lookup";
import { formatPrice } from "../../lib/matrix";

export const PartsTitle = ({ parts }) => (
  <div className="path-title">
    {parts.map((part, i) => (
      <React.Fragment key={part.id}>
        {i > 0 && <span className="path-plus">+</span>}
        <span className={`part part-${part.kind}`} title={part.name}>
          {part.kind === "plan" ? part.name : part.label}
        </span>
      </React.Fragment>
    ))}
  </div>
);

export const PriceBlock = ({ parts, total, estimated, symbol }) => {
  const priced = total !== null && total !== undefined;
  return (
    <div className="path-price">
      <div className="total">{priced ? formatPrice(total, symbol, estimated) : "\u2014"}</div>
      <div className="per">per user / month</div>
      {parts.length > 1 && (
        <div className="breakdown">
          {parts.map((x) => (x.price === null || x.price === undefined ? "?" : formatPrice(x.price, symbol, x.estimated))).join(" + ")}
        </div>
      )}
    </div>
  );
};

export default function PathCard({ path, rank, isCheapest, groupLabel, symbol }) {
  const priced = path.total !== null && path.total !== undefined;
  const addonNote = path.parts.find((x) => x.kind === "addon" && x.note)?.note;
  return (
    <li className={`path-card type-${path.type} ${isCheapest ? "cheapest" : ""}`} data-testid="lookup-path">
      <div className="path-rank">{rank}</div>
      <div className="path-main">
        <PartsTitle parts={path.parts} />
        <div className="path-meta">
          <span className={`badge badge-${path.type}`}>{TYPE_LABELS[path.type]}</span>
          {path.groupId && <span className="mini-chip">{groupLabel(path.groupId)}</span>}
          {path.level && <span className="mini-chip level">{path.level}</span>}
          {path.viaParent && <span className="path-note">via {path.viaParent}</span>}
          {path.estimated && <span className="mini-chip est" title="Converted from the US list price with Microsoft's regional ratio">{"\u2248"} estimated</span>}
          {isCheapest && (
            <span className="mini-chip cheapest">
              <Sparkles size={10} aria-hidden="true" /> cheapest
            </span>
          )}
        </div>
        {addonNote && <div className="path-note">{addonNote}</div>}
        {!priced && <div className="path-note warn">Add-on price not in dataset - total not available</div>}
      </div>
      <PriceBlock parts={path.parts} total={path.total} estimated={path.estimated} symbol={symbol} />
    </li>
  );
}
